import { FormControl, FormField, FormItem } from "../ui/form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import type { ChangeEvent } from "react";
import { FormInput } from "./form-input.components";

type FormInputProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label?: string;
	placeholder: string;
	required?: boolean;
	min?: number;
	disabled?: boolean;
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const FormPhoneInput = <T extends FieldValues>({
	form,
	name,
	label,
	placeholder,
	required,
	disabled,
	min,
}: FormInputProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormControl className="relative">
						<div className="flex items-center">
							<FormInput
								label={label}
								form={form}
								type="number"
								className="pl-24"
								placeholder={placeholder}
								disabled={disabled}
								min={min}
								required={required}
								{...field}
							/>
							<div className="left-0 absolute mt-6 ml-5 font-semibold text-xs tracking-wider cursor-pointer">
								<span>(IN) +91</span>
							</div>
						</div>
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
